import React from 'react';

import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { FilterDashboardEtat } from '../types';

interface FilterProps {
  setFilter: (value: Partial<FilterDashboardEtat>) => void;
  filter: Partial<FilterDashboardEtat>;
}

export default function Filter({
  filter,
  setFilter,
}: FilterProps): React.ReactElement {
  const { valid } = filter;

  function setDisplayInvalidEtat(event: CheckboxChangeEvent) {
    setFilter({
      ...filter,
      valid: !event.target.checked,
    });
  }

  return (
    <div className="dashboard-header-filter">
      <AntdCheckbox
        checked={!valid}
        onChange={setDisplayInvalidEtat}
        className="checkbox-etats-inactifs"
      >
        Afficher les états inactifs
      </AntdCheckbox>
    </div>
  );
}
